import { render, staticRenderFns } from "./maininvoicetable.vue?vue&type=template&id=52957b71"
import script from "./maininvoicetable.vue?vue&type=script&lang=js"
export * from "./maininvoicetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports